import { render, staticRenderFns } from "./CompArticlesSendArticle.vue?vue&type=template&id=0ec60d9a&scoped=true"
import script from "./CompArticlesSendArticle.vue?vue&type=script&setup=true&lang=js"
export * from "./CompArticlesSendArticle.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CompArticlesSendArticle.vue?vue&type=style&index=0&id=0ec60d9a&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec60d9a",
  null
  
)

export default component.exports